import React from 'react'
import { Trans, useTranslation } from 'react-i18next'

// Exit submits the server-rendered #ghost-exit-form (carries the CSRF token).
export const GhostBannerComponent = ({ companyName }: { companyName?: string }) => {
    const { t } = useTranslation()
    return (
        <div className="navbar-banner ghost-banner">
            <div className="container-fluid">
                <p>
                    <Trans
                        i18nKey="banners.ghosting"
                        values={{ company: companyName }}
                        components={{ 1: <strong /> }}
                    />
                    <button type="submit" form="ghost-exit-form" className="btn btn-xs btn-default">
                        {t('banners.exit')}
                    </button>
                </p>
            </div>
        </div>
    )
}
